export default [
  'coffee',
  'mug-hot',
  'check',
  'apple-alt',
  'hashtag',
  'angry',
  'users',
  'adjust',
  'atom',
  'comment-alt',
  'camera',
  'battery-three-quarters',
  'images',
  'image',
  'batery-full',
  'car',
  'cat',
  'dog',
  'gem',
  'comments',
  'comment',
  'spa',
  'ghost',
  'horse',
  'balance-scale',
  'balance-scale-right',
  'bicycle',
  'birthday-cake',
  'calendar-plus',
  'briefcase-medical',
  'dice-five',
  'dice-four',
  'dice-one',
  'dice-six',
  'dice-three',
  'dice-two',
  'divide',
  'egg',
  'edit',
  'exclamation-circle',
  'fan',
  'eye',
  'feather',
  'feather-alt',
  'file',
  'file-code',
  'laptop-code',
  'plane',
  'user-secret',
  'keyboard',
  'code',
  'mouse',
  'home',
  'igloo',
  'toilet-paper',
  'bed',
  'map',
  'newspaper',
  'scroll',
  'copy',
  'paperclip',
  'paper-plane',
  'hand-paper',
  'paste',
  'print',
  'cut',
  'cubes',
  'credit-card',
  'desktop',
  'fish',
  'flag',
  'flushed',
  'hamburger',
  'guitar',
  'horse-head',
  'kiss',
  'lemon',
  'meh',
  'mobile',
  'microchip',
  'rocket',
  'search',
  'sign',
  'signal',
  'skull',
  'smile',
  'star',
  'taxi',
  'tractor',
  'trash',
  'motorcycle',
]
